import { configureStore } from '@reduxjs/toolkit';
import { authSlice } from '@/store/slices/authSlice';
import { themeSlice } from '@/store/slices/themeSlice';
import { loadingSlice } from '@/store/slices/loadingSlice';



export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    theme: themeSlice.reducer,
    loading: loadingSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// Re-export types 
export type { RootState, AppDispatch } from '@/store/types';

// Export actions and async thunks
export { toggleTheme, setTheme, setPrimaryColor, setSecondaryColor, setCustomColors } from '@/store/slices/themeSlice';
export { clearError, setUser, setToken, clearAuth, loginUser, fetchProfile, logoutUser } from '@/store/slices/authSlice';
export { setLoading, setBackdropLoading, showLoader, hideLoader } from '@/store/slices/loadingSlice';


